/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import moment from 'moment';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

//  error msg dispatch function
export const dispatchErrorMsgActLabeler = (data) => ({
  type: actionTypes.GET_ERROR_MSG_ACTLABEL,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(dispatchErrorMsgActLabeler([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgActLabeler([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_ACTLABEL,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_ACTLABEL,
  detailScrData: data,
});
// dispatch Display screen Object
export const dispatchDisplayObjLabel = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_ACTLABEL,
  payload: data,
});
//refresh data
export const refreshActiveLabeler = () => ({
  type: actionTypes.SET_REFRESH_DATA_ACTLABEL,
  payload: {},
});
export const refreshActiveLabelerDisplay = () => ({
  type: actionTypes.REFRESH_ACTIVE_LABELER_DISPLAY,
  payload: {},
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_ACTLABEL,
  payload: data,
});

// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_ACTLABEL,
  payload: data,
});
// rebate program name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_ACTLABEL,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
//dispatch selected contact
export const dispatchContacts = (data) => ({
  type: actionTypes.GET_CONTACTS_ACTLABEL,
  payload: data,
});
//contacts dropdown
export const dispatchContactsDropdown = (data) => ({
  type: actionTypes.GET_CONTACTS_DROPDOWN,
  payload: data,
});
export const getContactsDropdown = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ACTIVE_LABELER_CONTACT, value)
    .then((response) => {
      return dispatch(dispatchContactsDropdown(response.data));
    })
    .catch((response) => {
      dispatch(dispatchContactsDropdown([]));
    });
};
export const dispatchContactsDropdownName = (data) => ({
  type: actionTypes.GET_CONTACTS_DROPDOWN_NAME,
  payload: data,
});
// dispatch active labeler data
export const dispatchActiveLabeler = (data) => ({
  type: actionTypes.SET_ACTIVE_LABELER_DATA,
  payload: data,
});
export const getActiveLabeler = (value) => (dispatch) => {
  dispatch(dispatchActiveLabeler([]));
  return axios
    .post(serviceEndPoint.GET_ACTIVE_LABELER_DATA, value)
    .then((response) => {
      if (response.data.activeLabelersReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchActiveLabeler(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchActiveLabeler([]));
    });
};
